<template>
  <div class="bg-white h-full pt-24">
    <ProfileBanner :userDetails="userDetails" />

    <div class="container">
      <div class="row">
        <div class="col-3-cust-res">
          <ProfileDetails :userDetails="userDetails" />
        </div>
        <div class="col-9-cust-res md:pl-8 lg:pl-8">
          <div class="md:mt-4 lg:mt-4 mt-6">
            <b-tabs
              active-nav-item-class="font-weight-bold  text-uppercase text-white bg-primary"
              active-tab-class="font-bold "
              content-class="mt-3 t"
              class="tab-title-u"
            >
              <b-tab title="Dashboard" active
                ><AboutMe :userDetails="userDetails" />
                <ContactUs :userDetails="userDetails"
              /></b-tab>
              <div v-if="userData.role == 'author'">
                <b-tab title="My Courses "
                  ><MyCourses :userDetails="userDetails"
                /></b-tab>
              </div>
              <div v-else-if="userData.role == 'student'">
                <b-tab title="My Learning "
                  ><MyLearningCard :userDetails="userDetails"
                /></b-tab>
              </div>

              <b-tab title="Settings"
                ><SettingForm :userDetails="userDetails"
              /></b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileBanner from "./components/ProfileBanner";
import ProfileDetails from "./components/ProfileDetails";
import AboutMe from "./components/AboutMe";
import ContactUs from "./components/ContactUs";
import MyCourses from "./components/MyCourses";
import "../scss/index.scss";
import SettingForm from "./components/SettingForm";
import { mapState } from "vuex";
import MyLearningCard from "./components/MyLearningCard.vue";
export default {
  data() {
    return {
      userDetails: {},
    };
  },
  methods: {
    async getAuthor() {
      const { data } = await this.$store.dispatch("author/getAuthorByUserId", {
        userId: this.userData._id,
      });
      // console.log(data[0]);
      this.userDetails = data[0];
      // console.log(this.authorData._id);
      // console.log(this.userData);
    },
    async getStudent() {
      const { data } = await this.$store.dispatch(
        "student/getStudentByUserId",
        {
          userId: this.userData._id,
        }
      );
      this.userDetails = data[0];
      // console.log(this.userDetails);
      // console.log(data);
      // console.log(this.userData._id);
    },
    sortUserData() {
      if (this.userData.role == "author") {
        this.getAuthor();
      } else {
        this.getStudent();
      }
    },
  },
  mounted() {
    this.sortUserData();
  },
  components: {
    ProfileBanner,
    ProfileDetails,
    AboutMe,
    ContactUs,
    MyCourses,
    SettingForm,
    MyLearningCard,
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
};
</script>
<style>
.profile-cover-h {
  height: 250px;
}

.profile-photo-w {
  width: 200px;
  height: 200px;
  margin-top: -8rem;
  border-radius: 0.5rem;
}
.bg-warning-light {
  background: #fb63401f !important;
}
.text-80808094 {
  color: #80808094;
}
.tab-title-u li a {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 10px;
  padding-bottom: 10px;
}
.card-topimg-h150 {
  height: 150px;
}
.fsize-rm {
  font-size: 0.875rem;
}
.col-3-cust-res {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
.col-9-cust-res {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
@media screen and (max-width: 640px) {
  .profile-cover-h {
    height: 150px;
  }
  .profile-photo-w {
    width: 130px;
    height: 130px;
    margin-top: -5rem;
    border-radius: 100%;
  }
  .tab-title-u li a {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 14px;
  }
  .col-3-cust-res {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col-9-cust-res {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
